import { gql } from "@apollo/client";
import { TerminalNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const MUTATION_UPDATE_TERMINAL = gql`
  ${TerminalNoNestingFragment}
  mutation UpdateTerminal($input: UpdateTerminalInput!) {
    updateTerminal(input: $input) {
      ...TerminalNoNesting
    }
  }
`;

export const MUTATION_ADD_PAYMENT_METHOD_TO_TERMINAL = gql`
  ${TerminalNoNestingFragment}
  mutation AddPaymentMethodToTerminal($terminalId: ID!, $paymentMethodId: ID!) {
    addPaymentMethodToTerminal(
      terminalId: $terminalId
      paymentMethodId: $paymentMethodId
    ) {
      ...TerminalNoNesting
    }
  }
`;

export const MUTATION_DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id) {
      result
    }
  }
`;
